import { Code, Server, Settings } from 'lucide-react';
import Title from '../Title/Title';
import s from './Skills.module.scss';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function Skills() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const skills = [
    {
      title: 'Frontend',
      icon: <Code size={24} />,
      description: 'Modern technologies for building web interfaces',
      skills: [
        'React',
        'Next.js',
        'TypeScript',
        'JavaScript',
        'Tailwind CSS',
        'SCSS',
        'Redux',
        'MobX',
        'React Query',
        'Framer Motion',
      ],
    },
    {
      title: 'Backend',
      icon: <Server size={24} />,
      description: 'Backend development, APIs, and data processing',
      skills: [
        'Python',
        'Django',
        'Flask',
        'FastAPI',
        'Node.js',
        'Express',
        'REST APIs',
        'Celery',
        'PostgreSQL',
        'Redis',
      ],
    },
    {
      title: 'AI & Cloud',
      icon: <Settings size={24} />,
      description: 'AI-powered products, cloud infrastructure, and development tools',
      skills: [
        'LLM',
        'RAG',
        'Embeddings',
        'AWS',
        'S3',
        'Docker',
        'Nginx',
        'Git',
        'Web3',
      ],
    },
  ];

  return (
    <section id="skills">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 12 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 12 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className={s.root_wrapper}
      >
        <Title text="Skills" size="large" className={s.header_title} />
        <p className={s.title_desc}>The technology stack and tools I use in development</p>
        <div className={s.root}>
          {skills.map((skill) => (
            <div className={s.skills} key={skill.title}>
              <div className={s.header}>
                <div className={s.header_icon}>{skill.icon}</div>
                <p>{skill.title}</p>
              </div>
              <p className={s.desc}>{skill.description}</p>
              <div className={s.skills_list}>
                {skill.skills.map((skill) => (
                  <div className={s.skill} key={skill}>{skill}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
